module.exports = __webpack_public_path__ + "static/media/library-outline.74115627.svg";